import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  FileText, 
  Settings, 
  ChevronLeft,
  LogOut,
  ExternalLink
} from 'lucide-react';
import { cn } from '../../lib/utils';

const navItems = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/admin' },
  { icon: FileText, label: 'Emendas', path: '/admin/emendas' },
  { icon: Settings, label: 'Configurações', path: '/admin/configuracoes' },
];

export const Sidebar = () => {
  return (
    <aside className="w-64 bg-slate-900 text-white h-screen fixed left-0 top-0 z-50 flex flex-col shadow-2xl transition-all duration-300">
      {/* Brand */}
      <div className="p-6 border-b border-slate-800/50 flex items-center gap-3">
        <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center font-bold text-lg shadow-lg shadow-blue-500/20">
          A
        </div>
        <div>
          <h1 className="font-bold text-sm tracking-tight leading-none text-slate-100">Painel ADM</h1>
          <p className="text-[10px] text-slate-500 font-medium uppercase mt-1">Institucional</p>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2 overflow-y-auto mt-4">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/admin'}
            className={({ isActive }) => cn(
              "flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 group",
              isActive 
                ? "bg-blue-600 text-white shadow-lg shadow-blue-600/20" 
                : "text-slate-400 hover:text-slate-100 hover:bg-slate-800/50"
            )}
          >
            <item.icon size={20} className={cn(
              "transition-transform group-hover:scale-110",
              "text-inherit"
            )} />
            {item.label}
          </NavLink>
        ))}
      </nav>

      {/* Bottom Actions */}
      <div className="p-4 border-t border-slate-800/50 space-y-2">
        <a 
          href="/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-slate-400 hover:text-slate-100 hover:bg-slate-800/50 transition-all border border-dashed border-slate-800 hover:border-slate-700"
        >
          <ExternalLink size={18} />
          Ver Site Público
        </a>
        <button className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium text-red-400 hover:text-red-300 hover:bg-red-400/10 transition-all">
          <LogOut size={18} />
          Sair do Sistema
        </button>
      </div>
    </aside>
  );
};
